/**
 * Корзина на фронте: состояние из /ajax/cart/state, дровер справа,
 * бейдж в шапке, кнопки [data-action="cart-add"]. Каждая мутация
 * получает полное состояние с сервера и перерисовывает дровер.
 */
import { api } from './api';
import { t, price } from './i18n';
import { notify } from './notify';

const state = {
    items: [],
    totals: { item_count: 0, total_price: 0 },
    loaded: false,
};

const listeners = [];

function emit() {

    listeners.forEach( fn => fn( state ) );
}

function apply( data ) {

    state.items  = data.items || [];
    state.totals = data.totals || { item_count: 0, total_price: 0 };
    state.loaded = true;

    document.querySelectorAll('[data-cart-count]').forEach( el => {
        el.textContent = state.totals.item_count;
    } );

    renderDrawer();
    emit();
}

function escape( text ) {

    return String( text ).replace( /[&<>"']/g, ch => ( {
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
    } )[ ch ] );
}

function renderDrawer() {

    const body   = document.querySelector('[data-cart-body]');
    const footer = document.querySelector('[data-cart-footer]');

    if( ! body )
        return;

    if( state.items.length === 0 ) {

        body.innerHTML = `
            <div class="cart-empty">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>
                <p>${ t('cart.empty') }</p>
                <small>${ t('cart.empty_hint') }</small>
            </div>`;

        if( footer )
            footer.innerHTML = `
                <a href="${ window.baseURL }/products" class="btn-primary" data-action="cart-close">
                    ${ t('cart.go_catalog') }
                    <svg class="btn-arrow" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 10h12m-4-4l4 4-4 4"/></svg>
                </a>`;

        return;
    }

    body.innerHTML = state.items.map( item => `
        <div class="cart-item" data-variation-id="${ item.variation_id }">
            <a class="cart-item-img" href="${ window.baseURL }/${ escape( item.slug ) }">
                ${ item.image ? `<img src="${ escape( item.image ) }" alt="">` : '' }
            </a>
            <div class="cart-item-info">
                <a class="cart-item-title" href="${ window.baseURL }/${ escape( item.slug ) }">${ escape( item.title ) }</a>
                ${ item.variation ? `<small>${ escape( item.variation ) }</small>` : '' }
                <div class="cart-item-row">
                    <div class="qty-controls">
                        <button class="qty-btn" type="button" data-action="cart-qty" data-delta="-1">−</button>
                        <div class="qty-value">${ item.quantity }</div>
                        <button class="qty-btn" type="button" data-action="cart-qty" data-delta="1">+</button>
                    </div>
                    <div class="cart-item-price">${ price( item.price * item.quantity ) }</div>
                </div>
            </div>
            <button class="cart-item-remove" type="button" data-action="cart-remove" aria-label="${ t('cart.remove') }">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg>
            </button>
        </div>` ).join('');

    if( footer )
        footer.innerHTML = `
            <div class="cart-total-row">
                <span>${ t('cart.total') }</span>
                <strong>${ price( state.totals.total_price ) }</strong>
            </div>
            <a href="${ window.baseURL }/checkout" class="btn-primary">
                ${ t('cart.checkout') }
                <svg class="btn-arrow" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 10h12m-4-4l4 4-4 4"/></svg>
            </a>
            <a href="${ window.baseURL }/cart" class="cart-link">${ t('cart.title') }</a>`;
}

export const cart = {

    state,

    onChange( fn ) {

        listeners.push( fn );
    },

    async load() {

        try {
            apply( await api.get('cart/state') );
        } catch( e ) {}

        return state;
    },

    async add( productId, variationId, quantity = 1 ) {

        const data = await api.post( 'cart/add', {
            product_id:   productId,
            variation_id: variationId,
            quantity,
        } );

        apply( data );
        notify( t('catalog.added'), 'success' );

        return state;
    },

    async quantity( variationId, quantity ) {

        apply( await api.post( 'cart/quantity', { variation_id: variationId, quantity } ) );

        return state;
    },

    async remove( variationId ) {

        apply( await api.post( 'cart/remove', { variation_id: variationId } ) );

        return state;
    },

    async select( variationId, selected ) {

        apply( await api.post( 'cart/select', { variation_id: variationId, selected } ) );

        return state;
    },
};
